// import { newEnforcer } from 'casbin.js';
import { getGlobalRole } from '../roleInfo';

// Custom Authorizer class to match existing interface
class Authorizer {
  private permissions: Record<string, any> = {};

  constructor(private mode: string) {}

  setPermission(permissions: Record<string, any>) {
    this.permissions = permissions;
  }

  can(action: string, resource: string, projectId?: any): Promise<boolean> {
    return new Promise((resolve) => {
      const actionPerms = this.permissions[action];
      if (!actionPerms) {
        resolve(false);
        return;
      }
      const hasPermission = actionPerms.includes('*') || actionPerms.includes(resource);
      resolve(hasPermission);
    });
  }
}

// Map roles to permissions

const rolePermissions: Record<string, any> = {
  SUPER_ADMIN: {
    read: [
      'projects',
      'sites',
      'surveys',
      'surveySets',
      'faqs',
      'notifications',
      'wallets',
      'users',
      'project_users',
    ],
    write: [
      'projects',
      'sites',
      'surveys',
      'surveySets',
      'faqs',
      'notifications',
      'wallets',
      'users',
      'project_users',
    ],
    delete: [
      'projects',
      'sites',
      'surveys',
      'surveySets',
      'faqs',
      'notifications',
      'wallets',
      'users',
      'project_users',
    ],
    edit: [
      'projects',
      'sites',
      'surveys',
      'surveySets',
      'faqs',
      'notifications',
      'wallets',
      'users',
      'project_users',
    ],
    export: [
      'projects',
      'sites',
      'surveys',
      'surveySets',
      'faqs',
      'notifications',
      'wallets',
      'users',
      'project_users',
    ],
  },
  ADMIN: {
    read: [
      'projects',
      'sites',
      'surveys',
      'surveySets',
      'faqs',
      'notifications',
      'wallets',
      'users',
      'project_users',
    ],
    write: [
      'projects',
      'sites',
      'surveys',
      'surveySets',
      'faqs',
      'notifications',
      'wallets',
      'project_users',
      'users',
    ],
    delete: [
      'projects',
      'sites',
      'surveys',
      'surveySets',
      'faqs',
      'notifications',
      'wallets',
      'project_users',
      'users',
    ],
    edit: [
      'projects',
      'sites',
      'surveys',
      'surveySets',
      'faqs',
      'notifications',
      'wallets',
      'project_users',
      'users',
    ],
    export: [
      'projects',
      'sites',
      'surveys',
      'surveySets',
      'faqs',
      'notifications',
      'wallets',
      'users',
      'project_users',
    ],
  },
  SURVEY_MANAGER: {
    read: ['*'],
    write: ['surveys', 'surveySets', 'project_users', 'sites', 'notifications'],
    edit: ['surveys', 'surveySets', 'project_users', 'sites', 'notifications'],
    delete: ['surveys', 'surveySets', 'project_users', 'notifications'],
    export: [
      'projects',
      'surveySets',
      'surveys',
      'project_users',
      'sites',
      'notifications',
      'users',
    ],
  },
  CONTENT_MODERATOR: {
    read: ['projects', 'surveySets', 'reports', 'visualizations'],
    export: [
      'projects',
      'sites',
      'surveys',
      'surveySets',
      'faqs',
      'notifications',
      'wallets',
      'project_users',
      'users',
    ],
  },
  VIEWER: {
    read: [
      'projects',
      'sites',
      'surveySets',
      'surveys',
      'faqs',
      'notifications',
      'wallets',
      'project_users',
    ],
    write: [],
    delete: [],
  },
};

export const createAuthorizer = (role?: string): Authorizer => {
  const roleName = role ?? getGlobalRole();
  const authorizer = new Authorizer('manual');
  authorizer.setPermission(rolePermissions[roleName] || {});
  return authorizer;
};
